module.exports = __webpack_public_path__ + "static/media/project1.eb70d4aa.png";